/**
 * 攔截器判斷
 */

import axios from 'axios';
import Global from '@/models/UI/Global';
import router from '@/router/index.js';
import { getLocalUserInfo, removeLocalUserInfo } from "@/models/HELPERS/common.js";

let loadingCount = 0; //計算請求數量


axios.interceptors.request.use(
    (confing) => {
        const meta = router.currentRoute.meta; // 訪問當前路由的meta信息
        const info = getLocalUserInfo(meta.authority);

        if (info && info.token) confing.headers.Authorization = `Bearer ${info.token}`;

        loadingCount ++;

        if(confing.is_loading) Global.$emit('isLoading', true);
        return confing;
    },
    (error) => {
        loadingCount ++;
        //延遲關閉loading時間，以免使用者在關閉loading後直接點擊，避免程式未跑完就執行操作
        setTimeout(()=>{
            Global.$emit('isLoading', false)
            // window.scrollTo(0,0)
        }, 500);
        return Promise.reject(error);
    }
);
  
axios.interceptors.response.use(
    (response) => {
        loadingCount --;
        //防止非同步問題導致loading提早被關閉
        if (loadingCount === 0){
            //延遲關閉loading時間，以免使用者在關閉loading後直接點擊，避免程式未跑完就執行操作
            setTimeout(()=>{
                Global.$emit('isLoading', false)
                // window.scrollTo(0,0)
            }, 500); 
        }
        return response;
    },
    (error) => {
        loadingCount --;
        //延遲關閉loading時間，以免使用者在關閉loading後直接點擊，避免程式未跑完就執行操作
        setTimeout(()=>{
            Global.$emit('isLoading', false)
            // window.scrollTo(0,0)
        }, 500);
        if (error.response) { 
            switch (error.response.status) { 
              case 401:  
                const meta = router.currentRoute.meta; // 訪問當前路由的meta信息
                if (meta.authority) removeLocalUserInfo(meta.authority);
                router.replace({ path: '/login'});
                break;
            }
            return Promise.reject(error);
        }
    }
);

export default axios;


// WEBPACK FOOTER //
// ./src/models/API/axios.js